import React, { useState, useMemo } from 'react'
import Modal from 'meinian-package/src/component/modal'
import { ELE, ELE_TYPE } from 'common/config/enum'
import { MultiSelect } from 'meinian-package/src/baseComponent/selectBorder'
import RuleLabel from '../../../component/ruleLabel'
import styles from './index.module.less'

export default ({ boxLabelRetList = [], picUrl, unionId, onClose, visible, onOk }) => {
  const [isRules, setIsRules] = useState(false)
  const [params, setParams] = useState({
    wrongTypes: [],
    category: []
  })

  const errorOption = useMemo(() => {
    const optionMap = new Map()
    boxLabelRetList.forEach(parent => {
      parent.finalLabelArray.forEach(child => {
        optionMap.set(child.type, { label: ELE_TYPE[ELE[child.type]], value: child.type })
      })
    })
    const _arr = Array.from(optionMap.values())
    const _findIndex = _arr.findIndex(i => i.value === 1 || i.value === 314)
    if (_findIndex !== -1) {
      _arr[_findIndex].label = '类目'
    }
    return _arr.filter(item => item.label)
  }, [boxLabelRetList])

  const categoryOption = useMemo(() => {
    const _arr = boxLabelRetList?.map(i => i.category)
    const _set = new Set([..._arr])
    return Array.from(_set)?.map(i => ({ label: i, value: i })) || []
  }, [boxLabelRetList])

  const isCategory = params.wrongTypes.find(item => item === 1 || item === 314) // 是否选择了类目

  const _onOk = async () => {
    setIsRules(true)
    if (params.wrongTypes.length) {
      if (isCategory && !params.category.length) {
        return false
      }
      return onOk({
        ...params,
        picUrl,
        unionId
      })
    }
  }

  return (<Modal
    onOk={_onOk}
    visible={visible}
    onClose={onClose}
    style={{ width: '480px' }}
    className={styles['mn-feedback-modal']}
    title={<div className="mn-feedback-modal-title">
      <div>提交反馈</div>
      <div className="mn-feedback-modal-sub-title">你的每一次反馈，都能帮助我们提高识别精准度，谢谢！</div>
    </div>}
  >
    <div className="mn-feedback-modal-content">
      <div className={styles['mn-form']}>
        <div className="mn-form-item">
          <RuleLabel label="请选择错误的地方" message="必填" isRules={isRules && !params.wrongTypes.length} />
          <Select
            option={errorOption}
            multi
            value={params.wrongTypes}
            allowClear={false}
            onChange={(item) => {
              setParams((pre) => {
                if (item) {
                  pre.wrongTypes = item
                  return { ...pre }
                }
                pre.wrongTypes = []
                return { ...pre }
              })
            }}
            className="mn-feedback-modal-select"
          />
        </div>
        {
          isCategory && <div className="mn-form-item">
            <RuleLabel label="能告诉我们是哪个品类吗？" message="必填" isRules={isRules && !params.category.length} />
            <Select
              option={categoryOption}
              multi
              allowClear={false}
              value={params.category}
              onChange={(item) => {
                setParams((pre) => {
                  if (item) {
                    pre.category = item
                    return { ...pre }
                  }
                  pre.category = []
                  return { ...pre }
                })
              }}
              className="mn-feedback-modal-select"
            />
          </div>
        }
      </div>
    </div>
  </Modal>)
}

const Select = (props) => {
  return <MultiSelect {...props} />
}
